import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_select_department = _resolveComponent("select-department")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_upload = _resolveComponent("upload")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_staff = _resolveComponent("staff")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.modalConfig.visible,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalConfig.visible) = $event)),
    title: _ctx.modalConfig.title,
    onOk: _ctx.handleOk,
    onCancel: _ctx.handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: _ctx.formState,
        ref: "formRef",
        rules: _ctx.rules,
        "label-col": { style: { width: '110px' } }
      }, {
        default: _withCtx(() => [
          (_ctx.formState.requirementName.show)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                label: "需求名称",
                name: "requirementName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_textarea, {
                    value: _ctx.formState.requirementName.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.requirementName.value) = $event)),
                    disabled: _ctx.formState.requirementName.disabled,
                    placeholder: "请输入需求名称",
                    allowClear: "",
                    "auto-size": ""
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formState.requirementContent.show)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 1,
                label: "需求内容",
                name: "requirementContent"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_textarea, {
                    value: _ctx.formState.requirementContent.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.requirementContent.value) = $event)),
                    disabled: _ctx.formState.requirementContent.disabled,
                    placeholder: "请输入需求内容",
                    allowClear: "",
                    "auto-size": ""
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formState.completeRequirementDept.show)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 2,
                label: "完成需求部门",
                name: "completeRequirementDept"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_department, {
                    onHandleSelectDepartment: _ctx.handleSelectDepartment,
                    department: _ctx.formState.completeRequirementDept
                  }, null, 8, ["onHandleSelectDepartment", "department"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formState.expectedDeliveryDate.show)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 3,
                label: "期望交付日期",
                name: "expectedDeliveryDate"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_date_picker, {
                    value: _ctx.formState.expectedDeliveryDate.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.expectedDeliveryDate.value) = $event)),
                    placeholder: "请选择期望交付日期",
                    onChange: _ctx.handleSelectDate,
                    disabled: _ctx.formState.expectedDeliveryDate.disabled
                  }, null, 8, ["value", "onChange", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formState.requirementFile.show)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 4,
                label: "需求文件",
                name: "requirementFile"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_upload, {
                    echoFile: _ctx.formState.requirementFile.value,
                    onSetUploadFileUrl: _ctx.setUploadFileUrl,
                    disabled: _ctx.formState.requirementFile.disabled,
                    action: _ctx.uploadTransDeptFile
                  }, null, 8, ["echoFile", "onSetUploadFileUrl", "disabled", "action"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formState.isReceive.show)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 5,
                label: "需求接收",
                name: "isReceive"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.formState.isReceive.value,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.isReceive.value) = $event)),
                    disabled: _ctx.formState.isReceive.disabled,
                    onChange: _ctx.handleIsReceiveChange,
                    placeholder: "需求接收",
                    allowClear: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: true }, {
                        default: _withCtx(() => [
                          _createTextVNode("是")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: false }, {
                        default: _withCtx(() => [
                          _createTextVNode("否")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "disabled", "onChange"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formState.executor.show && _ctx.formState.isReceive.value)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 6,
                label: "需求执行人",
                name: "executor"
              }, {
                default: _withCtx(() => [
                  (_ctx.executorAuthority)
                    ? (_openBlock(), _createBlock(_component_staff, {
                        key: 0,
                        echoStaff: _ctx.formState.executorId.value,
                        echostaffUserName: _ctx.formState.executor.value,
                        onGetChooseStaff: _ctx.getChooseStaff
                      }, null, 8, ["echoStaff", "echostaffUserName", "onGetChooseStaff"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.formState.executor.value), 1))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formState.isDelivery.show)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 7,
                label: "是否交付",
                name: "isDelivery"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.formState.isDelivery.value,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.isDelivery.value) = $event)),
                    disabled: _ctx.formState.isDelivery.disabled,
                    onChange: _ctx.handleIsDeliveryChange,
                    allowClear: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: true }, {
                        default: _withCtx(() => [
                          _createTextVNode("是")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "disabled", "onChange"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formState.deliveryFile.show)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 8,
                label: "交付文件",
                name: "deliveryFile"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_upload, {
                    echoFile: _ctx.formState.deliveryFile.value,
                    onSetUploadFileUrl: _ctx.setDeliveryFile,
                    disabled: _ctx.formState.deliveryFile.disabled,
                    action: _ctx.uploadTransDeptFile
                  }, null, 8, ["echoFile", "onSetUploadFileUrl", "disabled", "action"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formState.requirementDeliveryConfirmation.show)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 9,
                label: "交付确认",
                name: "requirementDeliveryConfirmation"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.formState.requirementDeliveryConfirmation.value,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.requirementDeliveryConfirmation.value) = $event)),
                    disabled: _ctx.formState.requirementDeliveryConfirmation.disabled,
                    onChange: _ctx.handleDelConfirmChange,
                    placeholder: "交付确认",
                    allowClear: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "确认" }, {
                        default: _withCtx(() => [
                          _createTextVNode("确认")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "进行中" }, {
                        default: _withCtx(() => [
                          _createTextVNode("进行中")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "退回" }, {
                        default: _withCtx(() => [
                          _createTextVNode("退回")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "disabled", "onChange"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["visible", "title", "onOk", "onCancel"]))
}